<template>
    <div v-if="feedItems" class="bg-teal-lightest rounded-full px-16 py-6 w-full md:w-3/5">
        <div class="flex items-center">
            <div class="border-teal-darker border-r-2 pr-4 mr-4 md:pr-12 md:mr-12">
                <p class="text-teal-darker text-2xl md:text-3xl">Recent<br/>activity</p>
            </div>

            <transition-group name="flip-list">
                <div v-for="(item, index) in feedItems" :key="item.id + index" class="lg:w-90">
                    <div v-if="isCurrentFeedItem(index)">
                        <div v-if="'unadopted_at' in item">
                            <p class="text-teal-darker text-lg mb-2">
                                <span class="font-bold text-xl">{{item.user && item.user.display_name}}</span>
                                {{formattedDate(item.created_at)}}
                            </p>

                            <p class="text-lg">
                                Adopted the drain
                                <span class="font-bold">{{item.name}}</span>!
                            </p>
                        </div>

                        <div v-else-if="'collected_amount' in item">
                            <p class="text-teal-darker text-lg mb-2">
                                <span class="font-bold text-xl">{{item.adoption && item.adoption.user.display_name}}</span>
                                {{formattedDate(item.created_at)}}
                            </p>

                            <p class="text-lg">
                                Collected <span class="font-bold">{{item.collected_amount_in_pounds}} lbs.</span> of debris from
                                <span class="font-bold">{{item.adoption && item.adoption.name}}</span>!
                            </p>
                        </div>

                        <div v-else>
                            <p class="text-teal-darker text-lg mb-2">
                                <span class="font-bold text-xl">{{item && item.display_name}}</span>
                                {{formattedDate(item.created_at)}}
                            </p>

                            <p class="text-lg">
                                Signed up for the Adopt-a-Drain program!
                            </p>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        'feedItems': null
    },

    data() {
        return {
            currentFeedItem: 0,
        }
    },

    mounted() {
        this.startCounter();
    },

    beforeDestroy() {
        this.clearInterval();
    },

    methods: {
        formattedDate(date) {
            return moment.utc(date).from(moment.utc().format());
        },

        isCurrentFeedItem(index) {
            return Number(index) === this.currentFeedItem;
        },

        startCounter() {
            setInterval(() => {
                (this.currentFeedItem + 1) === Object.keys(this.feedItems).length ? this.currentFeedItem = 0 : this.currentFeedItem++;
            }, 7000);
        }
    }
};
</script>

<style>
.flip-list-move {
    transition: transform 1s;
}
</style>


